
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="使用" fileName="base.md" />
        <demo-block>
        <div><p>1、<code>name</code>属性设置图标的名称<br> 2、<code>size</code>属性设置图标的大小<br> 3、<code>color</code>属性设置图标的颜色</p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;div&gt;
        &lt;ve-icon name=&quot;double-right-arrow&quot; /&gt;
        &lt;ve-icon name=&quot;double-right-arrow&quot; color=&quot;red&quot; /&gt;
        &lt;ve-icon name=&quot;double-right-arrow&quot; :size=&quot;40&quot; /&gt;
    &lt;/div&gt;
&lt;/template&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('ve-icon',{attrs:{"name":"double-right-arrow"}}),_vm._v(" "),_c('ve-icon',{attrs:{"name":"double-right-arrow","color":"red"}}),_vm._v(" "),_c('ve-icon',{attrs:{"name":"double-right-arrow","size":40}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  